unit ImportMappings;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  DB,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.ExtCtrls,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Data.DB, WEBLib.WebCtrls;

type
  TMappingFormMode = (mfmCreate, mfmEdit);

  TMappingColumnState = record
    ComboValue: string;
    HeaderText: string;
    SavedUserHeader: string;
    PreviewRows: TArray<string>;
  end;

  TMappingsForm = class(TCoreWebForm)
    ImportMapping: TXDataWebDataSet;
    ImportMappingId: TIntegerField;
    ImportMappingDateAdded: TDateTimeField;
    ImportMappingAddedBy: TIntegerField;
    ImportMappingLastUpdatedBy: TIntegerField;
    ImportMappingLastUpdated: TDateTimeField;
    ImportMappingName: TStringField;
    ImportMappingMapping: TStringField;
    ImportMappingHasTitles: TBooleanField;
    EditTimer: TTimer;
    WebPanel1: TPanel;
    ImportDataTable: TTableControl;
    FormCaption: TLabel;
    MappingNameEdit: TDBEdit;
    DataSource: TDataSource;
    SaveButton: TButton;
    CloseButton: TButton;
    CloseTimer: TTimer;
    FieldItemCheckDlg: TMessageDlg;
    DateDelimiterEdit: TEdit;
    DateFormatEdit: TEdit;
    FieldDelimiterCombo: TComboBox;
    FieldDelimiterNALabel: TLabel;
    LoadPreviewButton: TButton;
    PreviewFilePicker: TFilePicker;
    AddColumnButton: TButton;
    InsertAtStartButton: TButton;
    FirstRowIsHeadersCheckBox: TCheckBox;
    procedure WebFormShow(Sender: TObject);
    procedure CloseButtonClick(Sender: TObject);
    procedure CloseTimerTimer(Sender: TObject);
    procedure EditTimerTimer(Sender: TObject);
    procedure ImportMappingAfterOpen(Dataset: TDataSet);
    procedure ImportMappingAfterPost(Dataset: TDataSet);
    procedure MappingNameEditChange(Sender: TObject);
    procedure SaveButtonClick(Sender: TObject);
    procedure DateDelimiterEditKeyPress(Sender: TObject; var Key: Char);
    procedure DateFormatEditKeyPress(Sender: TObject; var Key: Char);
    procedure DateDelimiterEditExit(Sender: TObject);
    procedure DateFormatEditExit(Sender: TObject);
    procedure FieldDelimiterComboChange(Sender: TObject);
    procedure LoadPreviewButtonClick(Sender: TObject);
    procedure PreviewFilePickerChange(Sender: TObject);
    procedure AddColumnButtonClick(Sender: TObject);
    procedure InsertAtStartButtonClick(Sender: TObject);
    procedure FirstRowIsHeadersCheckBoxClick(Sender: TObject);
  private
    { Private declarations }
    fImportMapping: TDataSet;
    FImportRowData: TStringList;
    FJSONImportData: string;
    FDelimiter: char;
    FHasHeadings: boolean;
    fMappingName: string;
    [async]
    FJSONFileData: string;
    FTempFileName: string;
    FIsXLSFile: boolean;

    FDateFormat: string;
    FDateDelimiter: string;
    FRawLines: TArray<string>;
    FMappingComboGeneration: Integer;
    FFormMode: TMappingFormMode;
    FMappingId: Integer;
    FSavedUserHeaders: TArray<string>;
    FUsingPreviewHeaders: Boolean;
    FPreviewFileData: TArray<TArray<string>>;
    FMappingSaved: Boolean;
    FAutoMapAllColumns: Boolean;
    FAutoMappedFields: TArray<string>;
    FUpdatingComboBoxes: Boolean;

    procedure SetJSONFileData(JSONFileData: string);
    procedure ParseJSONImportData;
    procedure ParseExistingMappingData(const AMappingData: string);
    procedure AddDataToGrid(AColumnCount: integer; ARowCount: integer; ADataRow: TArray<string>);
    function TestFieldForHeader(AMapAllColumns: Boolean = True): boolean;
    function DetectHeaderMappings(AMapAllColumns: Boolean): boolean;
    procedure ApplyMappedFieldsDirect;
    procedure ConfigureGrid(HeaderData: TArray<string>; AColumnCount: integer);
    procedure CreateComboBoxes(AColumnCount: integer);
    procedure ConfigureFieldDelimiterCombo;
    procedure ClearMappingComboBoxes;
    procedure SplitImportLine(const ALine: string; ADelimiter: Char; AFields: TStringList);
    procedure RebuildPreviewGrid;
    function ParseRawLines(AData: TJSObject): TArray<string>;
    procedure UpdateComboBoxs;
    procedure SaveMapping;
    function ValidateMappingForSave: Boolean;
    function GetJSONMappingData: string;
    procedure SetDataset(Value: TDataSet);
    function GetMappingColumnCount(const AMappingObj: TJSObject): Integer;
    function GetMappingHeaderName(const AMappingObj: TJSObject; const AFieldName: string): string;
    function GetMappingColumnIndex(const AMappingObj: TJSObject; const AFieldName: string): Integer;
    [async]
    procedure CloseMappingForm; async;
    procedure ComboBoxChange(Sender: TObject);
    //function IsXLSNumericDate(ADate: string):boolean;
    function IsXLSNumericDate(AData: string; var ADateStr: string):boolean;
    function XLSFormatDate(lDataValue: string): string;
    procedure ApplyPendingMappingToUI;
    procedure AttachImportMappingRecord;
    procedure UpdateEditModeControls;
    procedure SetHasHeadings(AValue: Boolean);
    procedure UpdateHasHeadingsCheckBox;
    function GetUserTitleForColumn(AIdx: Integer): string;
    procedure ApplyPreviewToEditGrid(const AJSONFileData: string);
    [async]
    procedure UploadAndApplyPreview; async;
    procedure SetupDefaultCreateMapping;
    function ExtractColumnStates: TArray<TMappingColumnState>;
    procedure ApplyColumnStates(const AStates: TArray<TMappingColumnState>);
    procedure AddColumnAtEnd;
    procedure InvalidateRawLinesAfterColumnChange;
    procedure RenderColumnToolbars;
    procedure RegisterColumnDragForm;
    procedure FinalizeMappingGrid;
    function BuildColumnToolbarHtml(AIdx, AColCount: Integer): string;
    function BuildColumnTitleRowHtml(AIdx, AColCount: Integer; const AHeaderText: string): string;
    function RemoveColumnState(const AStates: TArray<TMappingColumnState>; AIndex: Integer): TArray<TMappingColumnState>;
    function EscapeMappingHtml(const S: string): string;
    function GetPreviewHeaderForColumn(AIdx: Integer): string;
    function GetPreviewCellForMappingColumn(AFileColIdx, AGridRow: Integer): string;
    function ResolveHeaderTextFromState(const AState: TMappingColumnState; AIdx: Integer): string;
    function ResolvePreviewCellFromState(const AState: TMappingColumnState; AIdx, AGridRow: Integer): string;
    function GetCleanHeaderLabel(AIdx: Integer): string;
    function GetColumnHeaderDisplayText(AIdx: Integer): string;
    procedure ClearMappingHeaderRow(AColumnCount: Integer);
    function GetHeaderTextForAutoMap(AIdx: Integer): string;
    function MatchHeaderToField(const AHeader: string): string;

  public
    { Public declarations }
    procedure AfterCreated; override;
    property JSONFileData: string read FJSONFileData write SetJSONFileData;
    property Delimiter: char read FDelimiter write FDelimiter;
    property MappingName: string read fMappingName write fMappingName;
    property TempFileName: string  read FTempFileName;
    property FormMode: TMappingFormMode read FFormMode write FFormMode;
    property MappingId: Integer read FMappingId write FMappingId;
    procedure LoadExistingMapping;
    procedure MoveColumn(AFromCol, AToCol: Integer);
    procedure InsertColumnAt(AIndex: Integer);
    procedure DeleteColumnAt(AIndex: Integer);
  protected procedure LoadDFMValues; override; end;

var
  MappingsForm: TMappingsForm;

procedure PrepareMappingEdit(const AMappingId: Integer; const AName: string = ''; const AMappingData: string = ''; AHasTitles: Boolean = False);
function MappingEditIsPrepared(const AMappingId: Integer): Boolean;
procedure PrepareMappingCreate;
function ConsumeLastSavedMappingName: string;
function MappingJsonHasRequiredFields(const AMappingJson: string): Boolean;
function GetMappingExpectedColumnCount(const AMappingJson: string): Integer;
function FormatImportMappingOptionLabel(const AName: string; const AMappingJson: string;
  ALastUpdated, ADateAdded: TDateTime): string;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  SMX.Web.Layout.Utils,
  SMX.Web.Utils,
  MainDataModule, SMX.Jobs.Shared,
  Types;

const
  ComboFieldItems = ',Title,Firstname,Middlename,Lastname,Suffix,FullName,Add1,Add2,Add3,City,County,' +
    'PostCode,FullAddress,Country,Date,Amount,ExternalId,External_DonationId,Sponsored';

  Date20200101 = 43831;  //Check its a date and above 01/01/2020

  SInvalidFileEncoding =
    'Your file is not encoded in a format that is recognised. Please contact the GiftAider team for advice';

  SUnsupportedFileType =
    'That file type is not supported. Please upload a CSV or Excel (.xlsx) file.';

var
  PendingMappingId: Integer = 0;
  PendingFormMode: TMappingFormMode = mfmCreate;
  PendingMappingName: string = '';
  PendingMappingData: string = '';
  PendingMappingHasTitles: Boolean = False;
  LastSavedMappingName: string = '';

procedure PrepareMappingEdit(const AMappingId: Integer; const AName: string = ''; const AMappingData: string = ''; AHasTitles: Boolean = False);
begin
  PendingMappingId := AMappingId;
  PendingFormMode := mfmEdit;
  PendingMappingName := AName;
  PendingMappingData := AMappingData;
  PendingMappingHasTitles := AHasTitles;
end;

function MappingEditIsPrepared(const AMappingId: Integer): Boolean;
begin
  Result := (PendingFormMode = mfmEdit) and (PendingMappingId = AMappingId);
end;

procedure PrepareMappingCreate;
begin
  PendingMappingId := 0;
  PendingFormMode := mfmCreate;
  PendingMappingName := '';
  PendingMappingData := '';
  PendingMappingHasTitles := False;
end;

function ConsumeLastSavedMappingName: string;
begin
  Result := LastSavedMappingName;
  LastSavedMappingName := '';
end;

function MappingFieldsHaveRequiredFields(const AFields: TStringList): Boolean;
var
  lIdx: Integer;
  lFieldName: string;
  lHasAmount, lHasDate, lHasFirstname, lHasLastname, lHasFullName: Boolean;
  lHasAdd1, lHasFullAddress, lHasPostCode: Boolean;
begin
  lHasAmount := False;
  lHasDate := False;
  lHasFirstname := False;
  lHasLastname := False;
  lHasFullName := False;
  lHasAdd1 := False;
  lHasFullAddress := False;
  lHasPostCode := False;

  for lIdx := 0 to AFields.Count - 1 do
  begin
    lFieldName := Trim(AFields[lIdx]);
    if SameText(lFieldName, 'Amount') then
      lHasAmount := True
    else if SameText(lFieldName, 'Date') then
      lHasDate := True
    else if SameText(lFieldName, 'Firstname') then
      lHasFirstname := True
    else if SameText(lFieldName, 'Lastname') then
      lHasLastname := True
    else if SameText(lFieldName, 'FullName') then
      lHasFullName := True
    else if SameText(lFieldName, 'Add1') then
      lHasAdd1 := True
    else if SameText(lFieldName, 'FullAddress') then
      lHasFullAddress := True
    else if SameText(lFieldName, 'PostCode') then
      lHasPostCode := True;
  end;

  Result := lHasAmount and lHasDate and lHasPostCode and
    (lHasFullName or (lHasFirstname and lHasLastname)) and
    (lHasAdd1 or lHasFullAddress);
end;

function GetMappingExpectedColumnCount(const AMappingJson: string): Integer;
const
  MappingFields: array[0..18] of string = (
    'Title', 'Firstname', 'Middlename', 'Lastname', 'Suffix', 'FullName', 'Add1', 'Add2', 'Add3', 'City',
    'County', 'PostCode', 'FullAddress', 'Country', 'Date', 'Amount',
    'ExternalId', 'External_DonationId', 'Sponsored');
var
  lObj: TJSObject;
  lFieldName: string;
  lIndex: Integer;
begin
  Result := 0;
  if AMappingJson = '' then
    Exit;

  try
    lObj := TJSJSON.parseObject(AMappingJson);
    if not Assigned(lObj) then
      Exit;

    if Assigned(lObj['ExpectedColumnCount']) then
    begin
      Result := JS.ToInteger(lObj['ExpectedColumnCount']);
      if Result > 0 then
        Exit;
    end;

    for lFieldName in MappingFields do
    begin
      if Assigned(lObj[lFieldName]) then
      begin
        lIndex := JS.ToInteger(lObj[lFieldName]);
        if lIndex >= Result then
          Result := lIndex + 1;
      end;
    end;
  except
    Result := 0;
  end;
end;

function FormatImportMappingOptionLabel(const AName: string; const AMappingJson: string;
  ALastUpdated, ADateAdded: TDateTime): string;
var
  lCols: Integer;
  lDate: TDateTime;
  lColsText, lDateText: string;
begin
  lCols := GetMappingExpectedColumnCount(AMappingJson);
  if lCols > 0 then
    lColsText := lCols.ToString
  else
    lColsText := '—';

  if ALastUpdated >= 1 then
    lDate := ALastUpdated
  else if ADateAdded >= 1 then
    lDate := ADateAdded
  else
    lDate := 0;

  if lDate >= 1 then
    lDateText := FormatDateTime('hh:nn ' + SYS_DATE_FORMAT, lDate)
  else
    lDateText := '—';

  Result := Format('%s (expected cols: %s, modified: %s)', [AName, lColsText, lDateText]);
end;

function MappingJsonHasRequiredFields(const AMappingJson: string): Boolean;
const
  MappingFieldNames: array[0..18] of string = (
    'Title', 'Firstname', 'Middlename', 'Lastname', 'Suffix', 'FullName', 'Add1', 'Add2', 'Add3', 'City',
    'County', 'PostCode', 'FullAddress', 'Country', 'Date', 'Amount',
    'ExternalId', 'External_DonationId', 'Sponsored');
var
  lObj: TJSObject;
  lFields: TStringList;
  lFieldName: string;
begin
  Result := False;
  if AMappingJson = '' then
    Exit;

  try
    lObj := TJSJSON.parseObject(AMappingJson);
    if not Assigned(lObj) then
      Exit;

    lFields := TStringList.Create;
    try
      for lFieldName in MappingFieldNames do
        if Assigned(lObj[lFieldName]) then
          lFields.Add(lFieldName);
      Result := MappingFieldsHaveRequiredFields(lFields);
    finally
      lFields.Free;
    end;
  except
    Result := False;
  end;
end;

procedure TMappingsForm.WebFormShow(Sender: TObject);
begin
  inherited;
  ApplyMappedFieldsDirect;
end;

procedure TMappingsForm.AfterCreated;
begin
  inherited;
  if PendingFormMode = mfmEdit then
  begin
    FFormMode := mfmEdit;
    FMappingId := PendingMappingId;
    ApplyPendingMappingToUI;
    ImportMapping.Load;
  end
  else if PendingFormMode = mfmCreate then
  begin
    FFormMode := mfmCreate;
    PendingMappingId := 0;
    PendingMappingName := '';
    PendingMappingData := '';
    PendingMappingHasTitles := False;
    PendingFormMode := mfmCreate;
    if FJSONImportData = '' then
      SetupDefaultCreateMapping
    else
    begin
      ApplyMappedFieldsDirect;
      if Assigned(FImportRowData) and (FImportRowData.Count > 9) then
        EditTimer.Interval := 150
      else
        EditTimer.Interval := 50;
      EditTimer.Enabled := True;
    end;
    ImportMapping.Load;
  end;
end;

procedure TMappingsForm.SetupDefaultCreateMapping;
const
  DefaultColumnCount = 6;
  DefaultFields: array[0..5] of string = ('Firstname', 'Lastname', 'Add1', 'PostCode', 'Date', 'Amount');
var
  lHeaders: TArray<string>;
  lIdx: Integer;
  lCombo: TComboBox;
begin
  FUsingPreviewHeaders := False;
  SetLength(FPreviewFileData, 0);
  SetLength(FRawLines, 0);
  if FDelimiter = #0 then
    FDelimiter := ',';
  SetHasHeadings(False);
  FIsXLSFile := False;

  SetLength(lHeaders, DefaultColumnCount);
  for lIdx := 0 to DefaultColumnCount - 1 do
    lHeaders[lIdx] := IntToStr(lIdx + 1);

  ClearMappingComboBoxes;
  ConfigureGrid(lHeaders, DefaultColumnCount);
  ClearMappingHeaderRow(DefaultColumnCount);
  FinalizeMappingGrid;
  CreateComboBoxes(DefaultColumnCount);

  for lIdx := 0 to DefaultColumnCount - 1 do
  begin
    lCombo := TComboBox(FImportRowData.Objects[lIdx]);
    if Assigned(lCombo) then
      lCombo.ItemIndex := lCombo.Items.IndexOf(DefaultFields[lIdx]);
  end;
  UpdateComboBoxs;

  ConfigureFieldDelimiterCombo;
  UpdateEditModeControls;
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.ApplyPendingMappingToUI;
var
  lMappingData: string;
begin
  lMappingData := PendingMappingData;

  if PendingMappingName <> '' then
  begin
    fMappingName := PendingMappingName;
    MappingNameEdit.Text := fMappingName;
  end;

  if lMappingData <> '' then
  begin
    SetHasHeadings(PendingMappingHasTitles);
    ParseExistingMappingData(lMappingData);
  end;

  PendingMappingId := 0;
  PendingMappingName := '';
  PendingMappingData := '';
  PendingMappingHasTitles := False;
  PendingFormMode := mfmCreate;
  UpdateEditModeControls;
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.UpdateEditModeControls;
begin
  LoadPreviewButton.Visible := FFormMode = mfmEdit;
  LoadPreviewButton.Enabled := LoadPreviewButton.Visible;
  AddColumnButton.Visible := True;
  InsertAtStartButton.Visible := True;
end;

procedure TMappingsForm.SetHasHeadings(AValue: Boolean);
begin
  FHasHeadings := AValue;
  UpdateHasHeadingsCheckBox;
end;

procedure TMappingsForm.UpdateHasHeadingsCheckBox;
begin
  if Assigned(FirstRowIsHeadersCheckBox) then
    FirstRowIsHeadersCheckBox.Checked := FHasHeadings;
end;

procedure TMappingsForm.FirstRowIsHeadersCheckBoxClick(Sender: TObject);
begin
  FMappingSaved := False;
  FHasHeadings := FirstRowIsHeadersCheckBox.Checked;
  FinalizeMappingGrid;
end;

function TMappingsForm.GetUserTitleForColumn(AIdx: Integer): string;
begin
  Result := GetCleanHeaderLabel(AIdx);
end;

function TMappingsForm.GetCleanHeaderLabel(AIdx: Integer): string;
begin
  if not FHasHeadings then
    Exit(IntToStr(AIdx + 1));

  if (AIdx >= 0) and (AIdx < Length(FSavedUserHeaders)) and (FSavedUserHeaders[AIdx] <> '') then
    Exit(FSavedUserHeaders[AIdx]);

  if FUsingPreviewHeaders and (Length(FPreviewFileData) > 0) then
    Exit(GetPreviewHeaderForColumn(AIdx));

  Result := IntToStr(AIdx + 1);
end;

function TMappingsForm.GetColumnHeaderDisplayText(AIdx: Integer): string;
begin
  if not Assigned(FImportRowData) or (AIdx < 0) or (AIdx >= FImportRowData.Count) then
    Exit('');

  Result := GetCleanHeaderLabel(AIdx);
end;

procedure TMappingsForm.ClearMappingHeaderRow(AColumnCount: Integer);
var
  Idx: Integer;
begin
  for Idx := 0 to AColumnCount - 1 do
  begin
    ImportDataTable.Cells[Idx, 0] := '';
    if Assigned(ImportDataTable.CellElements[Idx, 0]) then
      ImportDataTable.CellElements[Idx, 0].innerHTML := '';
  end;
end;

procedure TMappingsForm.ApplyPreviewToEditGrid(const AJSONFileData: string);
var
  lSavedCombos: TArray<string>;
  lIdx, lColCount, lItemIdx: Integer;
  lCombo: TComboBox;
begin
  SetLength(lSavedCombos, 0);
  if Assigned(FImportRowData) then
  begin
    SetLength(lSavedCombos, FImportRowData.Count);
    for lIdx := 0 to FImportRowData.Count - 1 do
    begin
      lCombo := TComboBox(FImportRowData.Objects[lIdx]);
      if Assigned(lCombo) then
        lSavedCombos[lIdx] := lCombo.Text
      else
        lSavedCombos[lIdx] := '';
    end;
  end;

  FJSONImportData := AJSONFileData;
  FUsingPreviewHeaders := True;
  FAutoMapAllColumns := True;
  ParseJSONImportData;

  if Assigned(FImportRowData) then
  begin
    lColCount := Length(lSavedCombos);
    if FImportRowData.Count < lColCount then
      lColCount := FImportRowData.Count;

    for lIdx := 0 to FImportRowData.Count - 1 do
    begin
      lCombo := TComboBox(FImportRowData.Objects[lIdx]);
      if not Assigned(lCombo) then
        Continue;
      lCombo.Items.DelimitedText := ComboFieldItems;
      lCombo.ItemIndex := 0;
      if lIdx <= High(FAutoMappedFields) then
        FAutoMappedFields[lIdx] := '';
    end;

    for lIdx := 0 to lColCount - 1 do
    begin
      if lSavedCombos[lIdx] = '' then
        Continue;

      lCombo := TComboBox(FImportRowData.Objects[lIdx]);
      if not Assigned(lCombo) then
        Continue;

      lItemIdx := lCombo.Items.IndexOf(lSavedCombos[lIdx]);
      if lItemIdx >= 0 then
        lCombo.ItemIndex := lItemIdx;

      if lIdx <= High(FAutoMappedFields) then
        FAutoMappedFields[lIdx] := lSavedCombos[lIdx];
    end;
    UpdateComboBoxs;
  end;

  FMappingSaved := False;
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.LoadPreviewButtonClick(Sender: TObject);
begin
  PreviewFilePicker.Files.Clear;
  asm
    var el = document.getElementById('PreviewFilePicker');
    if (el) el.click();
  end;
end;

procedure TMappingsForm.PreviewFilePickerChange(Sender: TObject);
begin
  UploadAndApplyPreview;
end;

procedure TMappingsForm.UploadAndApplyPreview;
var
  lFileName, lFile, JSONFileData: string;
  lRetval: TXDataClientResponse;
  lResult: TJSObject;
begin
  if (not Assigned(PreviewFilePicker.Files)) or (PreviewFilePicker.Files.Count = 0) then
    Exit;
  if PreviewFilePicker.Files.Count > 1 then
  begin
    DisplayMessage('Please select only one file.');
    PreviewFilePicker.Files.Clear;
    Exit;
  end;

  lFileName := PreviewFilePicker.Files[0].Name;
  lFile := await(string, PreviewFilePicker.Files[0].FileAsBase64);

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(
    'IGiftAiderService.ImportMappingUpload', [lFileName, lFile]));
  lResult := lRetval.ResultAsObject;
  JSONFileData := JS.ToString(lResult['value']);

  if JSONFileData = 'unrecoginsed-encoding' then
  begin
    DisplayMessage(SInvalidFileEncoding);
    Exit;
  end;

  if JSONFileData = 'unsupported-file-type' then
  begin
    DisplayMessage(SUnsupportedFileType);
    Exit;
  end;

  ApplyPreviewToEditGrid(JSONFileData);
  PreviewFilePicker.Files.Clear;
end;

procedure TMappingsForm.AttachImportMappingRecord;
begin
  if FMappingId <= 0 then
    Exit;
  if not ImportMapping.Active then
    Exit;
  if not ImportMapping.Locate('Id', FMappingId, []) then
    Exit;

  ImportMapping.Edit;
  if fMappingName <> '' then
    ImportMappingName.AsString := fMappingName;
end;

procedure TMappingsForm.ImportMappingAfterOpen(Dataset: TDataSet);
begin
  if FFormMode = mfmEdit then
    AttachImportMappingRecord
  else if (FFormMode = mfmCreate) and (ImportMapping.State = dsBrowse) then
    ImportMapping.Insert;
end;

procedure TMappingsForm.SplitImportLine(const ALine: string; ADelimiter: Char; AFields: TStringList);
begin
  AFields.QuoteChar := '"';
  AFields.Delimiter := ADelimiter;
  AFields.StrictDelimiter := True;
  AFields.DelimitedText := ALine;
end;

procedure TMappingsForm.ClearMappingComboBoxes;
var
  Idx, lColCount: Integer;
  lCombo: TComboBox;
begin
  lColCount := ImportDataTable.ColCount;
  if lColCount > 0 then
  begin
    for Idx := 0 to lColCount - 1 do
    begin
      ImportDataTable.Cells[Idx, 1] := '';
      ImportDataTable.CellElements[Idx, 1].innerHTML := '';
      ImportDataTable.CellElements[Idx, 0].innerHTML := '';
    end;
  end;

  if not Assigned(FImportRowData) then
    Exit;

  for Idx := 0 to FImportRowData.Count - 1 do
  begin
    lCombo := TComboBox(FImportRowData.Objects[Idx]);
    if Assigned(lCombo) then
    begin
      FImportRowData.Objects[Idx] := nil;
      lCombo.Free;
    end;
  end;

  FreeAndNil(FImportRowData);
end;

function TMappingsForm.ParseRawLines(AData: TJSObject): TArray<string>;
var
  lArr: TJSArray;
  I: Integer;
begin
  SetLength(Result, 0);
  if not assigned(AData) or not assigned(AData['RawLines']) then
    Exit;

  lArr := TJSArray(AData['RawLines']);
  SetLength(Result, lArr.Length);
  for I := 0 to lArr.Length - 1 do
    Result[I] := JS.ToString(lArr[I]);
end;

procedure TMappingsForm.ConfigureFieldDelimiterCombo;
begin
  if FIsXLSFile then
  begin
    FieldDelimiterCombo.Visible := False;
    FieldDelimiterNALabel.Visible := True;
    FieldDelimiterNALabel.Caption := 'Not applicable (Excel file)';
  end
  else
  begin
    FieldDelimiterCombo.Visible := True;
    FieldDelimiterNALabel.Visible := False;

    if FieldDelimiterCombo.Items.Count = 0 then
    begin
      FieldDelimiterCombo.Items.Add('Comma (,)');
      FieldDelimiterCombo.Items.Add('Semicolon (;)');
      FieldDelimiterCombo.Items.Add('Tab');
      FieldDelimiterCombo.Items.Add('Pipe (|)');
    end;

    FieldDelimiterCombo.OnChange := nil;
    FieldDelimiterCombo.ItemIndex := FieldDelimiterComboIndex(string(FDelimiter));
    FieldDelimiterCombo.OnChange := FieldDelimiterComboChange;
  end;
end;

procedure TMappingsForm.FieldDelimiterComboChange(Sender: TObject);
begin
  if FIsXLSFile then
    Exit;

  FDelimiter := FieldDelimiterFromComboIndex(FieldDelimiterCombo.ItemIndex);
  RebuildPreviewGrid;
end;

procedure TMappingsForm.RebuildPreviewGrid;
var
  lIdx, lRowIdx, lColumnCount, ColIdx, RowIdx: Integer;
  lRowData: TArray<string>;
  ts: TStringList;
begin
  if FIsXLSFile or (Length(FRawLines) = 0) then
    Exit;

  ts := TStringList.Create;
  try
    SplitImportLine(FRawLines[0], FDelimiter, ts);
    lColumnCount := ts.Count;
    if lColumnCount = 0 then
      Exit;

    SetLength(lRowData, lColumnCount);
    for lIdx := 0 to lColumnCount - 1 do
      lRowData[lIdx] := ts[lIdx];
  finally
    ts.Free;
  end;

  ClearMappingComboBoxes;
  ConfigureGrid(lRowData, lColumnCount);

  for RowIdx := 0 to ImportDataTable.RowCount - 1 do
    for ColIdx := 0 to lColumnCount - 1 do
      if RowIdx <> 1 then
        ImportDataTable.Cells[ColIdx, RowIdx] := '';

  SetLength(FPreviewFileData, 1);
  FPreviewFileData[0] := lRowData;
  SetLength(FSavedUserHeaders, lColumnCount);
  for lIdx := 0 to lColumnCount - 1 do
    FSavedUserHeaders[lIdx] := lRowData[lIdx];
  ClearMappingHeaderRow(lColumnCount);

  for lIdx := 1 to Length(FRawLines) - 1 do
  begin
    ts := TStringList.Create;
    try
      SplitImportLine(FRawLines[lIdx], FDelimiter, ts);
      SetLength(lRowData, ts.Count);
      for lRowIdx := 0 to ts.Count - 1 do
        lRowData[lRowIdx] := ts[lRowIdx];
      AddDataToGrid(lColumnCount, lIdx + 1, lRowData);
    finally
      ts.Free;
    end;
  end;

  FinalizeMappingGrid;
  CreateComboBoxes(lColumnCount);
  if FHasHeadings then
    TestFieldForHeader(True)
  else
    UpdateComboBoxs;
  ConfigureFieldDelimiterCombo;
end;

procedure TMappingsForm.ConfigureGrid(HeaderData: TArray<string>; AColumnCount: integer);
var
  ColIdx, RowIdx: integer;
  lHeaderName: string;
begin
  FImportRowData := TStringList.Create;
  if FDelimiter <> #0 then
    FImportRowData.Delimiter := FDelimiter
  else
    FImportRowData.Delimiter := ',';

  for lHeaderName in HeaderData do
    FImportRowData.Add(lHeaderName);

  ImportDataTable.ColCount := AColumnCount;
  ImportDataTable.RowCount := 7;
end;

procedure TMappingsForm.CreateComboBoxes(AColumnCount: integer);
var
  DataComboBox: TComboBox;
  Idx: integer;
  ComboNameId: string;
begin
  Inc(FMappingComboGeneration);

  for Idx := 0 to AColumnCount - 1 do
  begin
    ImportDataTable.Cells[Idx, 1] := '';
    ImportDataTable.CellElements[Idx, 1].innerHTML := '';

    DataComboBox := TComboBox.Create(Self);
    ComboNameId := Format('WebCombo%d_%d', [FMappingComboGeneration, Idx]);
    DataComboBox.Parent := WebPanel1;
    DataComboBox.ElementID := ComboNameId;
    DataComboBox.Name := ComboNameId;
    DataComboBox.ElementClassName := 'form-select';
    DataComboBox.ElementPosition := epIgnore;
    DataComboBox.HeightStyle := ssAuto;
    DataComboBox.WidthStyle := ssAuto;
    FImportRowData.Objects[Idx] := DataComboBox;
    DataComboBox.Items.DelimitedText := ComboFieldItems;
    DataComboBox.OnChange := ComboBoxChange;
    ImportDataTable.CellElements[Idx, 1].appendChild(DataComboBox.ElementHandle);
  end;
end;

procedure TMappingsForm.DateDelimiterEditExit(Sender: TObject);
begin
  inherited;
  FDateDelimiter := DateDelimiterEdit.Text;
end;

procedure TMappingsForm.DateDelimiterEditKeyPress(Sender: TObject;
  var Key: Char);
begin
  DateDelimiterEdit.Text := '';
  if Key in ['0'..'9', 'a'..'z', 'A'..'Z'] then
    Key := #0;
end;

procedure TMappingsForm.DateFormatEditExit(Sender: TObject);
begin
  inherited;
  FDateFormat := DateFormatEdit.Text;
end;

procedure TMappingsForm.DateFormatEditKeyPress(Sender: TObject; var Key: Char);
begin
  if (not (Key in ['d', 'D','m', 'M', 'y', 'Y']))  then
    Key := #0
  else if ((Pos(Key, DateFormatEdit.Text) <> 0) or (Pos(Key, Lowercase(DateFormatEdit.Text)) <> 0)) then
    Key := #0;
end;

procedure TMappingsForm.ParseJSONImportData;
var
  JSImportData: TJSObject;
  lFileName: string;
  lIdx: integer;
  lRowCount: integer;
  lColumnCount: integer;
  lJSONImportData: string;
  lImportData: TImportData;
  lData: TArray<TArray<string>>;
  lRowData: TArray<string>;
  lDetectedHeadings: Boolean;

begin
  lJSONImportData := FJSONImportData;
  JSImportData := TJSJSON.parseObject(lJSONImportData);
  lImportData := TImportData(JSImportData);

  lFileName := lImportData.OriginalFileName;
  FTempFileName := lImportData.TempFileName;

  if Pos('.xls', lFileName) > 0 then
    FIsXLSFile := true
  else
    FIsXLSFile := false;

  lColumnCount := lImportData.ColCount;
  SetHasHeadings(lImportData.HasTitles);
  if lImportData.FieldDelimiter <> '' then
    FDelimiter := lImportData.FieldDelimiter[1]
  else
    FDelimiter := ',';
  FRawLines := ParseRawLines(JSImportData);
  lData := lImportData.Data;
  FPreviewFileData := lData;
  lRowCount := Length(lData);

  if lRowCount < 1 then
    Exit;

  ClearMappingComboBoxes;
  ConfigureGrid(lData[0], lColumnCount);
  SetLength(FSavedUserHeaders, lColumnCount);
  for lIdx := 0 to lColumnCount - 1 do
    if lIdx < Length(lData[0]) then
      FSavedUserHeaders[lIdx] := lData[0][lIdx]
    else
      FSavedUserHeaders[lIdx] := '';

  ClearMappingHeaderRow(lColumnCount);

  for lIdx := 1 to lRowCount - 1 do
  begin
    lRowData := lData[lIdx];
    AddDataToGrid(lColumnCount, lIdx + 1, lRowData);
  end;

  FinalizeMappingGrid;
  CreateComboBoxes(lColumnCount);
  lDetectedHeadings := TestFieldForHeader(FAutoMapAllColumns);
  SetHasHeadings(FHasHeadings or lDetectedHeadings);
  FAutoMapAllColumns := False;
  ConfigureFieldDelimiterCombo;
  UpdateEditModeControls;
end;

function TMappingsForm.GetMappingColumnIndex(const AMappingObj: TJSObject; const AFieldName: string): Integer;
begin
  Result := -1;
  if Assigned(AMappingObj) and Assigned(AMappingObj[AFieldName]) then
    Result := JS.ToInteger(AMappingObj[AFieldName]);
end;

function TMappingsForm.GetMappingHeaderName(const AMappingObj: TJSObject; const AFieldName: string): string;
var
  lKey: string;
begin
  Result := '';
  lKey := 'user' + AFieldName;
  if Assigned(AMappingObj) and Assigned(AMappingObj[lKey]) then
    Result := JS.ToString(AMappingObj[lKey]);
end;

function TMappingsForm.GetMappingColumnCount(const AMappingObj: TJSObject): Integer;
const
  MappingFields: array[0..18] of string = (
    'Title', 'Firstname', 'Middlename', 'Lastname', 'Suffix', 'FullName', 'Add1', 'Add2', 'Add3', 'City',
    'County', 'PostCode', 'FullAddress', 'Country', 'Date', 'Amount',
    'ExternalId', 'External_DonationId', 'Sponsored');
var
  lFieldName: string;
  lIndex: Integer;
begin
  Result := 0;
  if not Assigned(AMappingObj) then
    Exit;

  if Assigned(AMappingObj['ExpectedColumnCount']) then
  begin
    Result := JS.ToInteger(AMappingObj['ExpectedColumnCount']);
    if Result > 0 then
      Exit;
  end;

  for lFieldName in MappingFields do
  begin
    lIndex := GetMappingColumnIndex(AMappingObj, lFieldName);
    if lIndex >= Result then
      Result := lIndex + 1;
  end;
end;

procedure TMappingsForm.ParseExistingMappingData(const AMappingData: string);
const
  MappingFields: array[0..18] of string = (
    'Title', 'Firstname', 'Middlename', 'Lastname', 'Suffix', 'FullName', 'Add1', 'Add2', 'Add3', 'City',
    'County', 'PostCode', 'FullAddress', 'Country', 'Date', 'Amount',
    'ExternalId', 'External_DonationId', 'Sponsored');
var
  lObj: TJSObject;
  lHeaders: TArray<string>;
  lFieldName: string;
  lColumnCount: Integer;
  lColumnIndex: Integer;
  lCombo: TComboBox;
begin
  ClearMappingComboBoxes;

  lObj := TJSJSON.parseObject(AMappingData);
  if not Assigned(lObj) then
    Exit;

  lColumnCount := GetMappingColumnCount(lObj);
  if lColumnCount <= 0 then
    Exit;

  SetLength(lHeaders, lColumnCount);
  SetLength(FSavedUserHeaders, lColumnCount);
  for lColumnIndex := 0 to lColumnCount - 1 do
  begin
    lHeaders[lColumnIndex] := IntToStr(lColumnIndex + 1);
    FSavedUserHeaders[lColumnIndex] := '';
  end;

  for lFieldName in MappingFields do
  begin
    lColumnIndex := GetMappingColumnIndex(lObj, lFieldName);
    if (lColumnIndex >= 0) and (lColumnIndex < Length(FSavedUserHeaders)) then
      FSavedUserHeaders[lColumnIndex] := GetMappingHeaderName(lObj, lFieldName);
  end;

  FUsingPreviewHeaders := False;
  SetLength(FPreviewFileData, 0);

  ConfigureGrid(lHeaders, lColumnCount);
  ClearMappingHeaderRow(lColumnCount);
  FinalizeMappingGrid;
  CreateComboBoxes(lColumnCount);

  for lFieldName in MappingFields do
  begin
    lColumnIndex := GetMappingColumnIndex(lObj, lFieldName);
    if (lColumnIndex >= 0) and (lColumnIndex < FImportRowData.Count) then
    begin
      lCombo := TComboBox(FImportRowData.Objects[lColumnIndex]);
      if Assigned(lCombo) then
        lCombo.ItemIndex := lCombo.Items.IndexOf(lFieldName);
    end;
  end;
  UpdateComboBoxs;

  if Assigned(lObj['DateFormat']) then
    FDateFormat := JS.ToString(lObj['DateFormat'])
  else
    FDateFormat := '';

  if Assigned(lObj['DateDelimiter']) then
    FDateDelimiter := JS.ToString(lObj['DateDelimiter'])
  else
    FDateDelimiter := '';

  if Assigned(lObj['FieldDelimiter']) and (Length(JS.ToString(lObj['FieldDelimiter'])) > 0) then
    FDelimiter := JS.ToString(lObj['FieldDelimiter'])[1]
  else if FDelimiter = #0 then
    FDelimiter := ',';

  DateFormatEdit.Text := FDateFormat;
  DateDelimiterEdit.Text := FDateDelimiter;
  ConfigureFieldDelimiterCombo;
end;

function TMappingsForm.ExtractColumnStates: TArray<TMappingColumnState>;
var
  Idx, RowIdx: Integer;
  lCombo: TComboBox;
begin
  if not Assigned(FImportRowData) then
  begin
    SetLength(Result, 0);
    Exit;
  end;

  SetLength(Result, FImportRowData.Count);
  for Idx := 0 to FImportRowData.Count - 1 do
  begin
    lCombo := TComboBox(FImportRowData.Objects[Idx]);
    if Assigned(lCombo) then
      Result[Idx].ComboValue := lCombo.Text
    else
      Result[Idx].ComboValue := '';

    Result[Idx].HeaderText := GetCleanHeaderLabel(Idx);
    if Idx < Length(FSavedUserHeaders) then
      Result[Idx].SavedUserHeader := FSavedUserHeaders[Idx]
    else
      Result[Idx].SavedUserHeader := '';

    SetLength(Result[Idx].PreviewRows, ImportDataTable.RowCount - 2);
    for RowIdx := 2 to ImportDataTable.RowCount - 1 do
      Result[Idx].PreviewRows[RowIdx - 2] := ImportDataTable.Cells[Idx, RowIdx];
  end;
end;

procedure TMappingsForm.ApplyColumnStates(const AStates: TArray<TMappingColumnState>);
var
  Idx, RowIdx: Integer;
  lHeaders: TArray<string>;
  lCombo: TComboBox;
  lColumnCount: Integer;
  lCellValue: string;
begin
  lColumnCount := Length(AStates);
  if lColumnCount = 0 then
    Exit;

  ClearMappingComboBoxes;

  SetLength(lHeaders, lColumnCount);
  SetLength(FSavedUserHeaders, lColumnCount);
  for Idx := 0 to lColumnCount - 1 do
  begin
    lHeaders[Idx] := ResolveHeaderTextFromState(AStates[Idx], Idx);
    FSavedUserHeaders[Idx] := AStates[Idx].SavedUserHeader;
  end;

  ConfigureGrid(lHeaders, lColumnCount);
  ClearMappingHeaderRow(lColumnCount);

  for Idx := 0 to lColumnCount - 1 do
    for RowIdx := 2 to ImportDataTable.RowCount - 1 do
    begin
      lCellValue := ResolvePreviewCellFromState(AStates[Idx], Idx, RowIdx);
      ImportDataTable.Cells[Idx, RowIdx] := lCellValue;
    end;

  FinalizeMappingGrid;
  CreateComboBoxes(lColumnCount);

  for Idx := 0 to lColumnCount - 1 do
  begin
    lCombo := TComboBox(FImportRowData.Objects[Idx]);
    if Assigned(lCombo) and (AStates[Idx].ComboValue <> '') then
      lCombo.ItemIndex := lCombo.Items.IndexOf(AStates[Idx].ComboValue);
  end;
  UpdateComboBoxs;
end;

procedure TMappingsForm.InvalidateRawLinesAfterColumnChange;
begin
  SetLength(FRawLines, 0);
end;

procedure TMappingsForm.InsertColumnAt(AIndex: Integer);
var
  States, NewStates: TArray<TMappingColumnState>;
  NewCol: TMappingColumnState;
  i: Integer;
begin
  if not Assigned(FImportRowData) then
    Exit;

  States := ExtractColumnStates;
  if (AIndex < 0) or (AIndex > Length(States)) then
    Exit;

  NewCol.ComboValue := '';
  NewCol.HeaderText := '';
  NewCol.SavedUserHeader := '';
  SetLength(NewCol.PreviewRows, ImportDataTable.RowCount - 2);

  SetLength(NewStates, Length(States) + 1);
  for i := 0 to AIndex - 1 do
    NewStates[i] := States[i];
  NewStates[AIndex] := NewCol;
  for i := AIndex to High(States) do
    NewStates[i + 1] := States[i];

  InvalidateRawLinesAfterColumnChange;
  ApplyColumnStates(NewStates);
end;

procedure TMappingsForm.AddColumnAtEnd;
begin
  if Assigned(FImportRowData) then
    InsertColumnAt(FImportRowData.Count);
end;

procedure TMappingsForm.DeleteColumnAt(AIndex: Integer);
var
  States: TArray<TMappingColumnState>;
begin
  if not Assigned(FImportRowData) then
    Exit;
  if FImportRowData.Count <= 1 then
    Exit;

  States := ExtractColumnStates;
  if (AIndex < 0) or (AIndex >= Length(States)) then
    Exit;

  States := RemoveColumnState(States, AIndex);
  InvalidateRawLinesAfterColumnChange;
  ApplyColumnStates(States);
end;

function TMappingsForm.RemoveColumnState(const AStates: TArray<TMappingColumnState>; AIndex: Integer): TArray<TMappingColumnState>;
var
  i, j: Integer;
begin
  SetLength(Result, Length(AStates) - 1);
  j := 0;
  for i := 0 to High(AStates) do
    if i <> AIndex then
    begin
      Result[j] := AStates[i];
      Inc(j);
    end;
end;

procedure TMappingsForm.MoveColumn(AFromCol, AToCol: Integer);
var
  States: TArray<TMappingColumnState>;
  Combos: TArray<string>;
  lMovedCombo: string;
  i: Integer;
begin
  if not Assigned(FImportRowData) then
    Exit;
  if (AFromCol < 0) or (AToCol < 0) or (AFromCol >= FImportRowData.Count) or (AToCol >= FImportRowData.Count) then
    Exit;
  if AFromCol = AToCol then
    Exit;

  States := ExtractColumnStates;

  // Reordering only ever moves the field dropdowns. Column headers, position
  // numbers and any file preview data stay anchored to their positions - the
  // source columns (from a file, an existing mapping, or the default numbered
  // columns) never change identity, only the field assigned to each one does.
  SetLength(Combos, Length(States));
  for i := 0 to High(States) do
    Combos[i] := States[i].ComboValue;

  lMovedCombo := Combos[AFromCol];
  if AToCol > AFromCol then
    for i := AFromCol to AToCol - 1 do
      Combos[i] := Combos[i + 1]
  else
    for i := AFromCol downto AToCol + 1 do
      Combos[i] := Combos[i - 1];
  Combos[AToCol] := lMovedCombo;

  for i := 0 to High(States) do
    States[i].ComboValue := Combos[i];

  InvalidateRawLinesAfterColumnChange;
  ApplyColumnStates(States);
end;

function TMappingsForm.BuildColumnTitleRowHtml(AIdx, AColCount: Integer; const AHeaderText: string): string;
begin
  Result := '<div class="mapping-col-title-row">';
  if AIdx > 0 then
    Result := Result + Format(
      '<button type="button" draggable="false" class="mapping-col-btn mapping-col-move-btn" data-action="left" data-col="%d" title="Move left">&#8592;</button>',
      [AIdx])
  else
    Result := Result + '<span class="mapping-col-move-placeholder" aria-hidden="true"></span>';

  Result := Result + '<span class="mapping-col-title">' + EscapeMappingHtml(AHeaderText) + '</span>';

  if AIdx < AColCount - 1 then
    Result := Result + Format(
      '<button type="button" draggable="false" class="mapping-col-btn mapping-col-move-btn" data-action="right" data-col="%d" title="Move right">&#8594;</button>',
      [AIdx])
  else
    Result := Result + '<span class="mapping-col-move-placeholder" aria-hidden="true"></span>';
  Result := Result + '</div>';
end;

function TMappingsForm.BuildColumnToolbarHtml(AIdx, AColCount: Integer): string;
begin
  Result := '';
  if AColCount > 1 then
    Result := Result + Format(
      '<button type="button" draggable="false" class="mapping-col-btn mapping-col-delete" data-action="delete" data-col="%d" title="Delete column">x</button>',
      [AIdx]);
  Result := Result + Format(
    '<button type="button" draggable="false" class="mapping-col-btn" data-action="insert" data-col="%d" title="Insert column after">+</button>',
    [AIdx]);
end;

function TMappingsForm.GetPreviewHeaderForColumn(AIdx: Integer): string;
begin
  if (Length(FPreviewFileData) > 0) and (Length(FPreviewFileData[0]) > AIdx) then
    Result := FPreviewFileData[0][AIdx]
  else
    Result := IntToStr(AIdx + 1);
end;

function TMappingsForm.GetPreviewCellForMappingColumn(AFileColIdx, AGridRow: Integer): string;
var
  lFileRow: Integer;
begin
  Result := '';
  if Length(FPreviewFileData) = 0 then
    Exit;

  lFileRow := AGridRow - 1;
  if (lFileRow < 0) or (lFileRow >= Length(FPreviewFileData)) then
    Exit;
  if AFileColIdx >= Length(FPreviewFileData[lFileRow]) then
    Exit;

  Result := FPreviewFileData[lFileRow][AFileColIdx];
end;

function TMappingsForm.ResolveHeaderTextFromState(const AState: TMappingColumnState; AIdx: Integer): string;
begin
  if not FHasHeadings then
    Exit(IntToStr(AIdx + 1));

  if AState.SavedUserHeader <> '' then
    Exit(AState.SavedUserHeader);

  if FUsingPreviewHeaders and (Length(FPreviewFileData) > 0) then
    Exit(GetPreviewHeaderForColumn(AIdx));

  Result := IntToStr(AIdx + 1);
end;

function TMappingsForm.ResolvePreviewCellFromState(const AState: TMappingColumnState; AIdx, AGridRow: Integer): string;
var
  lStateRowIdx: Integer;
begin
  lStateRowIdx := AGridRow - 2;
  if (lStateRowIdx >= 0) and (lStateRowIdx <= High(AState.PreviewRows)) and (AState.PreviewRows[lStateRowIdx] <> '') then
    Exit(AState.PreviewRows[lStateRowIdx]);

  if FUsingPreviewHeaders and (Length(FPreviewFileData) > 0) then
    Result := GetPreviewCellForMappingColumn(AIdx, AGridRow)
  else
    Result := '';
end;

function TMappingsForm.EscapeMappingHtml(const S: string): string;
begin
  Result := S;
  Result := StringReplace(Result, '&', '&amp;', [rfReplaceAll]);
  Result := StringReplace(Result, '<', '&lt;', [rfReplaceAll]);
  Result := StringReplace(Result, '>', '&gt;', [rfReplaceAll]);
  Result := StringReplace(Result, '"', '&quot;', [rfReplaceAll]);
end;

procedure TMappingsForm.RenderColumnToolbars;
var
  Idx: Integer;
  lHeaderText: string;
  lColCount: Integer;
  lCell: TJSHTMLElement;
begin
  if not Assigned(FImportRowData) then
    Exit;

  lColCount := FImportRowData.Count;

  for Idx := 0 to lColCount - 1 do
  begin
    lHeaderText := GetCleanHeaderLabel(Idx);
    lCell := ImportDataTable.CellElements[Idx, 0];
    ImportDataTable.Cells[Idx, 0] := '';
    lCell.innerHTML := '';
    lCell.innerHTML :=
      '<div class="mapping-col-header">' +
      BuildColumnTitleRowHtml(Idx, lColCount, lHeaderText) +
      '<span class="mapping-col-toolbar">' + BuildColumnToolbarHtml(Idx, lColCount) + '</span>' +
      '</div>';
    lCell.classList.add('mapping-col-header-cell');
    lCell.setAttribute('draggable', 'true');
    lCell.setAttribute('data-col-index', IntToStr(Idx));
    lCell.setAttribute('title', 'Drag to reorder');
  end;
end;

procedure TMappingsForm.RegisterColumnDragForm;
begin
  asm
    window.GiftAiderMappingColumnForm = this;
  end;
end;

procedure TMappingsForm.FinalizeMappingGrid;
begin
  RenderColumnToolbars;
  RegisterColumnDragForm;
end;

procedure TMappingsForm.AddColumnButtonClick(Sender: TObject);
begin
  AddColumnAtEnd;
end;

procedure TMappingsForm.InsertAtStartButtonClick(Sender: TObject);
begin
  InsertColumnAt(0);
end;

procedure TMappingsForm.AddDataToGrid(AColumnCount: integer; ARowCount: integer; ADataRow: TArray<string>);
var
  lCol, lRow: integer;
  lDataValue: string;
  lFormattedDate: string;
begin
  lRow := ARowCount;
  try
    try
      for lCol := 0 to Length(ADataRow) - 1 do
      begin
        lDataValue := ADataRow[lCol];

        if FIsXLSFile and IsXLSNumericDate(lDataValue, lFormattedDate) then
          ImportDataTable.Cells[lCol, lRow] := lFormattedDate
        else
          ImportDataTable.Cells[lCol, lRow] := lDataValue;
      end;
    except

    end;
  finally

  end;
end;

procedure TMappingsForm.CloseButtonClick(Sender: TObject);
begin
  inherited;
  CloseMappingForm;
end;

procedure TMappingsForm.CloseMappingForm;
var
  res: TModalResult;
begin
  if FMappingSaved or (not ImportMapping.Active) or not (ImportMapping.State in dsEditModes) then
  begin
    ModalResult := mrClose;
    Exit;
  end;

  res := await(TModalResult,
    MessageDlgAsync('Are you sure you want to cancel this mapping? Any changes will not be saved', mtConfirmation, [mbYes, mbNo]));
  if res = mrYes then
  begin
    if ImportMapping.State in dsEditModes then
      ImportMapping.Cancel;
    ModalResult := mrClose;
  end;
end;

procedure TMappingsForm.CloseTimerTimer(Sender: TObject);
begin
  // inherited;
  CloseTimer.Enabled := False;
  ModalResult := mrOK;
end;

procedure TMappingsForm.EditTimerTimer(Sender: TObject);
begin
  inherited;
  EditTimer.Enabled := False;

  if FFormMode = mfmEdit then
  begin
    if ImportMapping.Active then
      LoadExistingMapping
    else
      ImportMapping.Load;
  end
  else
  begin
    if not ImportMapping.Active then
      ImportMapping.Load
    else if ImportMapping.State = dsBrowse then
      ImportMapping.Insert;
  end;

  ApplyMappedFieldsDirect;
end;

procedure TMappingsForm.SaveButtonClick(Sender: TObject);
begin
  inherited;
  if not ValidateMappingForSave then
    Exit;

  SaveMapping;
  FMappingSaved := True;
  SaveButton.Enabled := False;
  CloseTimer.Enabled := true;
end;

function TMappingsForm.ValidateMappingForSave: Boolean;
var
  lIdx: Integer;
  lCombo: TComboBox;
  lFieldName: string;
  lSeenFields: TStringList;
  lDuplicates: TStringList;
  lHasMappedField: Boolean;
begin
  Result := False;
  fMappingName := Trim(MappingNameEdit.Text);
  if fMappingName = '' then
  begin
    DisplayMessage('Please enter a mapping name.');
    Exit;
  end;

  if not Assigned(FImportRowData) or (FImportRowData.Count < 1) then
  begin
    DisplayMessage('Add at least one column to the mapping.');
    Exit;
  end;

  lSeenFields := TStringList.Create;
  lDuplicates := TStringList.Create;
  try
    lSeenFields.Sorted := True;
    lSeenFields.Duplicates := dupIgnore;
    lDuplicates.Sorted := True;
    lDuplicates.Duplicates := dupIgnore;

    lHasMappedField := False;

    for lIdx := 0 to FImportRowData.Count - 1 do
    begin
      lCombo := TComboBox(FImportRowData.Objects[lIdx]);
      if not Assigned(lCombo) then
        Continue;

      lFieldName := Trim(lCombo.Text);
      if lFieldName = '' then
        Continue;

      lHasMappedField := True;
      if lSeenFields.IndexOf(lFieldName) >= 0 then
        lDuplicates.Add(lFieldName)
      else
        lSeenFields.Add(lFieldName);
    end;

    if not lHasMappedField then
    begin
      DisplayMessage('Map at least one column to a GiftAider field before saving.');
      Exit;
    end;

    if lDuplicates.Count > 0 then
    begin
      DisplayMessage('Each GiftAider field can only be mapped once. Duplicate: ' + lDuplicates[0] + '.');
      Exit;
    end;

    if not MappingFieldsHaveRequiredFields(lSeenFields) then
    begin
      DisplayMessage(
        'Map all required fields before saving: Amount, Date, PostCode, a name (FullName or Firstname and Lastname), ' +
        'and an address (Add1 or FullAddress).');
      Exit;
    end;

    Result := True;
  finally
    lSeenFields.Free;
    lDuplicates.Free;
  end;
end;

function TMappingsForm.GetJSONMappingData: string;
var
  Idx: integer;
  sFieldName: string;
  WC_Object: TJSObject;
  MyString: string;
  JSONData: string;
  MapData: string;
  FieldCombo: TComboBox;
  FieldTitle: string;
  UserTitle: string;
  lLen: integer;

begin
  JSONData := '{ ';
  for Idx := 0 to FImportRowData.Count - 1 do
  begin
    FieldCombo := TComboBox(FImportRowData.Objects[Idx]);

    if assigned(FieldCombo) then
    begin
      FieldTitle := FieldCombo.Text;
      UserTitle := GetUserTitleForColumn(Idx);

      if FieldTitle <> '' then
      begin
        MapData := Format('"%s":%d,', [FieldTitle, Idx]);
        JSONData := JSONData + MapData;
        MapData := Format('"user%s":"%s",', [FieldTitle, UserTitle]);
        JSONData := JSONData + MapData;
      end;
    end;
  end;

  if FDateFormat <> '' then
  begin
    MapData := Format('"%s":"%s",', ['DateFormat', FDateFormat]);
    JSONData := JSONData + MapData;
  end;

  if FDateDelimiter <> '' then
  begin
    MapData := Format('"%s":"%s",', ['DateDelimiter', FDateDelimiter]);
    JSONData := JSONData + MapData;
  end;

  if FDelimiter <> #0 then
  begin
    MapData := Format('"%s":"%s",', ['FieldDelimiter', FDelimiter]);
    JSONData := JSONData + MapData;
  end;

  if Assigned(FImportRowData) and (FImportRowData.Count > 0) then
  begin
    MapData := Format('"%s":%d,', ['ExpectedColumnCount', FImportRowData.Count]);
    JSONData := JSONData + MapData;
  end;

  lLen := Length(JSONData);
  JSONData[lLen] := ' ';
  JSONData := JSONData + '}';
  result := JSONData;
end;

procedure TMappingsForm.ImportMappingAfterPost(Dataset: TDataSet);
begin
  inherited;
  ImportMapping.ApplyUpdates;
end;

procedure TMappingsForm.MappingNameEditChange(Sender: TObject);
begin
  inherited;
  FMappingSaved := False;
  fMappingName := MappingNameEdit.Text;

  // if FMappingName <> '' then
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.SetDataset(Value: TDataSet);
begin
  DataSource.Dataset := Value;
end;

procedure TMappingsForm.SetJSONFileData(JSONFileData: string);
begin
  FFormMode := mfmCreate;
  FJSONImportData := JSONFileData;
  FUsingPreviewHeaders := True;
  FAutoMapAllColumns := True;
  ParseJSONImportData;
end;

procedure TMappingsForm.LoadExistingMapping;
var
  lMappingData: string;
begin
  FFormMode := mfmEdit;
  if FMappingId = 0 then
    FMappingId := PendingMappingId;

  if not ImportMapping.Active then
    Exit;

  if not ImportMapping.Locate('Id', FMappingId, []) then
    Exit;

  ImportMapping.Edit;
  fMappingName := ImportMappingName.AsString;
  MappingNameEdit.Text := fMappingName;
  SetHasHeadings(ImportMappingHasTitles.AsBoolean);
  lMappingData := ImportMappingMapping.AsString;

  PendingMappingId := 0;
  PendingMappingName := '';
  PendingMappingData := '';
  PendingMappingHasTitles := False;
  PendingFormMode := mfmCreate;

  if lMappingData <> '' then
    ParseExistingMappingData(lMappingData);

  UpdateEditModeControls;
  SaveButton.Enabled := fMappingName <> '';
end;

procedure TMappingsForm.UpdateComboBoxs;
var
  lIdx, lOtherIdx, lFieldIdx: Integer;
  lCombo, lOtherCombo: TComboBox;
  lCurrentValue, lFieldName: string;
  lAllFields, lItems: TStringList;
  lUsedElsewhere: Boolean;
begin
  if not Assigned(FImportRowData) or FUpdatingComboBoxes then
    Exit;

  FUpdatingComboBoxes := True;
  lAllFields := TStringList.Create;
  lItems := TStringList.Create;
  try
    lAllFields.StrictDelimiter := True;
    lAllFields.Delimiter := ',';
    lAllFields.DelimitedText := ComboFieldItems;

    lItems.StrictDelimiter := True;
    lItems.Delimiter := ',';

    for lIdx := 0 to FImportRowData.Count - 1 do
    begin
      lCombo := TComboBox(FImportRowData.Objects[lIdx]);
      if not Assigned(lCombo) then
        Continue;

      lCurrentValue := Trim(lCombo.Text);
      lItems.Clear;
      lItems.Add('');

      for lFieldIdx := 0 to lAllFields.Count - 1 do
      begin
        lFieldName := Trim(lAllFields[lFieldIdx]);
        if lFieldName = '' then
          Continue;

        if SameText(lFieldName, lCurrentValue) then
        begin
          lItems.Add(lFieldName);
          Continue;
        end;

        lUsedElsewhere := False;
        for lOtherIdx := 0 to FImportRowData.Count - 1 do
        begin
          if lOtherIdx = lIdx then
            Continue;
          lOtherCombo := TComboBox(FImportRowData.Objects[lOtherIdx]);
          if Assigned(lOtherCombo) and SameText(Trim(lOtherCombo.Text), lFieldName) then
          begin
            lUsedElsewhere := True;
            Break;
          end;
        end;

        if not lUsedElsewhere then
          lItems.Add(lFieldName);
      end;

      lCombo.Items.DelimitedText := lItems.DelimitedText;

      if lCurrentValue = '' then
        lCombo.ItemIndex := 0
      else
      begin
        lFieldIdx := lCombo.Items.IndexOf(lCurrentValue);
        if lFieldIdx >= 0 then
          lCombo.ItemIndex := lFieldIdx
        else
          lCombo.ItemIndex := 0;
      end;
    end;
  finally
    lAllFields.Free;
    lItems.Free;
    FUpdatingComboBoxes := False;
  end;
end;

procedure TMappingsForm.SaveMapping;
var
  MappingData: string;
begin
  if not Assigned(FImportRowData) or (FImportRowData.Count < 1) then
    Exit;

  fMappingName := MappingNameEdit.Text;
  LastSavedMappingName := fMappingName;
  MappingData := GetJSONMappingData;

  if MappingData <> '' then
  begin
    ImportMapping.FieldByName('Name').AsString := fMappingName;
    ImportMapping.FieldByName('Mapping').AsString := MappingData;
    ImportMapping.FieldByName('HasTitles').AsBoolean := FHasHeadings;
    ImportMapping.Post;
  end;
end;


function TMappingsForm.GetHeaderTextForAutoMap(AIdx: Integer): string;
begin
  if (AIdx >= 0) and (AIdx < Length(FSavedUserHeaders)) and (FSavedUserHeaders[AIdx] <> '') then
    Exit(FSavedUserHeaders[AIdx]);

  if FUsingPreviewHeaders and (Length(FPreviewFileData) > 0) then
    Exit(GetPreviewHeaderForColumn(AIdx));

  if Assigned(FImportRowData) and (AIdx >= 0) and (AIdx < FImportRowData.Count) then
    Exit(FImportRowData[AIdx]);

  Result := '';
end;

function TMappingsForm.MatchHeaderToField(const AHeader: string): string;

  function TestHead(const ATest, AHeaderText: string): boolean;
  begin
    Result := Pos(Uppercase(ATest), Uppercase(AHeaderText)) > 0;
  end;

begin
  Result := '';
  if TestHead('FullName', AHeader) then
    Exit('FullName');
  if TestHead('FullAddress', AHeader) then
    Exit('FullAddress');
  if TestHead('Title', AHeader) then
    Exit('Title');
  if TestHead('First', AHeader) or TestHead('GivenName', AHeader) or TestHead('Christian', AHeader) then
    Exit('Firstname');
  if TestHead('Middle', AHeader) then
    Exit('Middlename');
  if TestHead('Last', AHeader) or TestHead('Surname', AHeader) then
    Exit('Lastname');
  if TestHead('Suffix', AHeader) then
    Exit('Suffix');
  if TestHead('Add1', AHeader) or TestHead('Address1', AHeader) then
    Exit('Add1');
  if TestHead('Add2', AHeader) or TestHead('Address2', AHeader) then
    Exit('Add2');
  if TestHead('Add3', AHeader) or TestHead('Address3', AHeader) then
    Exit('Add3');
  if TestHead('City', AHeader) then
    Exit('City');
  if TestHead('County', AHeader) then
    Exit('County');
  if TestHead('Post', AHeader) then
    Exit('PostCode');
  if TestHead('Country', AHeader) then
    Exit('Country');
  if TestHead('Date', AHeader) then
    Exit('Date');
  if TestHead('Amount', AHeader) or (TestHead('Donation', AHeader) and
     (not TestHead('Date', AHeader)) and (not TestHead('ID', AHeader))) then
    Exit('Amount');
  if TestHead('External', AHeader) and TestHead('Id', AHeader) then
    Exit('ExternalId');
  if (TestHead('Ext', AHeader) and TestHead('Donor', AHeader)) or
     (TestHead('Donor', AHeader) and TestHead('Id', AHeader)) then
    Exit('ExternalId');
  if (TestHead('Ext', AHeader) and TestHead('Donat', AHeader)) or
     (TestHead('Donat', AHeader) and TestHead('Id', AHeader)) then
    Exit('External_DonationId');
  if TestHead('Spons', AHeader) then
    Exit('Sponsored');
end;

procedure TMappingsForm.ApplyMappedFieldsDirect;
var
  Idx: Integer;
  lCombo: TComboBox;
  lFieldName: string;
  lItemIdx: Integer;
begin
  if not Assigned(FImportRowData) or (Length(FAutoMappedFields) = 0) then
    Exit;
  if not Assigned(FImportRowData.Objects[0]) then
    Exit;

  for Idx := 0 to FImportRowData.Count - 1 do
  begin
    if Idx > High(FAutoMappedFields) then
      Break;

    lFieldName := FAutoMappedFields[Idx];
    if lFieldName = '' then
      Continue;

    lCombo := TComboBox(FImportRowData.Objects[Idx]);
    if not Assigned(lCombo) then
      Continue;

    lItemIdx := lCombo.Items.IndexOf(lFieldName);
    if lItemIdx >= 0 then
      lCombo.ItemIndex := lItemIdx;
  end;
end;

function TMappingsForm.DetectHeaderMappings(AMapAllColumns: Boolean): boolean;
var
  Idx: Integer;
  lValue, lResult: string;
  lCombo: TComboBox;
  lItemIdx: Integer;
  lUsedFields: TStringList;

  function IsFieldUsed(const AFieldName: string): Boolean;
  var
    lUsedIdx: Integer;
  begin
    for lUsedIdx := 0 to lUsedFields.Count - 1 do
      if SameText(lUsedFields[lUsedIdx], AFieldName) then
        Exit(True);
    Result := False;
  end;

begin
  Result := False;
  if not Assigned(FImportRowData) then
    Exit;

  lUsedFields := TStringList.Create;
  try
    if not AMapAllColumns then
      for Idx := 0 to FImportRowData.Count - 1 do
      begin
        lCombo := TComboBox(FImportRowData.Objects[Idx]);
        if Assigned(lCombo) and (Trim(lCombo.Text) <> '') then
          lUsedFields.Add(Trim(lCombo.Text));
      end;

    SetLength(FAutoMappedFields, FImportRowData.Count);
    for Idx := 0 to FImportRowData.Count - 1 do
    begin
      FAutoMappedFields[Idx] := '';
      lCombo := TComboBox(FImportRowData.Objects[Idx]);
      if (not AMapAllColumns) and Assigned(lCombo) and (Trim(lCombo.Text) <> '') then
        Continue;

      lValue := Trim(GetHeaderTextForAutoMap(Idx));
      lResult := MatchHeaderToField(lValue);
      if (lResult <> '') and (not IsFieldUsed(lResult)) then
      begin
        FAutoMappedFields[Idx] := lResult;
        lUsedFields.Add(lResult);
        Result := True;
        if Assigned(lCombo) then
        begin
          lItemIdx := lCombo.Items.IndexOf(lResult);
          if lItemIdx >= 0 then
            lCombo.ItemIndex := lItemIdx;
        end;
      end
      else if AMapAllColumns and Assigned(lCombo) then
        lCombo.ItemIndex := 0;
    end;
  finally
    lUsedFields.Free;
  end;
end;

function TMappingsForm.TestFieldForHeader(AMapAllColumns: Boolean): boolean;
begin
  Result := DetectHeaderMappings(AMapAllColumns);
  if Assigned(FImportRowData) and (FImportRowData.Count > 0) and
     Assigned(FImportRowData.Objects[0]) then
    ApplyMappedFieldsDirect;
  UpdateComboBoxs;
end;

procedure TMappingsForm.ComboBoxChange(Sender: TObject);
begin
  if FUpdatingComboBoxes then
    Exit;

  FMappingSaved := False;
  UpdateComboBoxs;
end;

function TMappingsForm.IsXLSNumericDate(AData: string; var ADateStr: string):boolean;
var
  lIsXLS: boolean;
  lPos: integer;
  lDate: TDateTime;
begin
  lPos := Pos('.', AData);
  //Reduce checking
  if lPos > 0 then
  begin
    try
      lDate := strtofloat(AData);
      lIsXLS := true;
    except
      lIsXLS := False;
    end;

    if lIsXLS then
    begin
      if lDate > Date20200101 then
      begin
        ADateStr := FormatDateTime('dd/mm/yyyy', lDate);
        lIsXLS := True
      end
      else
        lIsXLS := False;
    end;
  end
  else
    lIsXLS := False;

  result := lIsXLS;
end;

function TMappingsForm.XLSFormatDate(lDataValue: string): string;
var
  lDataVal: double;
  lDateStr: string;
begin
  lDataVal := lDataValue.ToDouble;

  lDateStr := FormatDateTime('dd/mm/yyyy', lDataVal);

  result := lDateStr;
end;


procedure TMappingsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  FormCaption := TLabel.Create('FormCaption');
  FieldDelimiterNALabel := TLabel.Create('FieldDelimiterNALabel');
  WebPanel1 := TPanel.Create(Self);
  ImportDataTable := TTableControl.Create('MappingTable');
  MappingNameEdit := TDBEdit.Create('MappingNameEdit');
  SaveButton := TButton.Create('SaveButton');
  CloseButton := TButton.Create('CloseButton');
  FieldItemCheckDlg := TMessageDlg.Create(Self);
  DateDelimiterEdit := TEdit.Create('DateDelimiter');
  DateFormatEdit := TEdit.Create('DateFormat');
  FieldDelimiterCombo := TComboBox.Create('FieldDelimiterCombo');
  LoadPreviewButton := TButton.Create('LoadPreviewButton');
  PreviewFilePicker := TFilePicker.Create('PreviewFilePicker');
  AddColumnButton := TButton.Create('AddColumnButton');
  InsertAtStartButton := TButton.Create('InsertAtStartButton');
  FirstRowIsHeadersCheckBox := TCheckBox.Create('FirstRowIsHeadersCheckBox');
  ImportMapping := TXDataWebDataSet.Create(Self);
  ImportMappingId := TIntegerField.Create(Self);
  ImportMappingDateAdded := TDateTimeField.Create(Self);
  ImportMappingAddedBy := TIntegerField.Create(Self);
  ImportMappingLastUpdatedBy := TIntegerField.Create(Self);
  ImportMappingLastUpdated := TDateTimeField.Create(Self);
  ImportMappingName := TStringField.Create(Self);
  ImportMappingMapping := TStringField.Create(Self);
  ImportMappingHasTitles := TBooleanField.Create(Self);
  EditTimer := TTimer.Create(Self);
  DataSource := TDataSource.Create(Self);
  CloseTimer := TTimer.Create(Self);

  FormCaption.BeforeLoadDFMValues;
  FieldDelimiterNALabel.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  ImportDataTable.BeforeLoadDFMValues;
  MappingNameEdit.BeforeLoadDFMValues;
  SaveButton.BeforeLoadDFMValues;
  CloseButton.BeforeLoadDFMValues;
  FieldItemCheckDlg.BeforeLoadDFMValues;
  DateDelimiterEdit.BeforeLoadDFMValues;
  DateFormatEdit.BeforeLoadDFMValues;
  FieldDelimiterCombo.BeforeLoadDFMValues;
  LoadPreviewButton.BeforeLoadDFMValues;
  PreviewFilePicker.BeforeLoadDFMValues;
  AddColumnButton.BeforeLoadDFMValues;
  InsertAtStartButton.BeforeLoadDFMValues;
  FirstRowIsHeadersCheckBox.BeforeLoadDFMValues;
  ImportMapping.BeforeLoadDFMValues;
  ImportMappingId.BeforeLoadDFMValues;
  ImportMappingDateAdded.BeforeLoadDFMValues;
  ImportMappingAddedBy.BeforeLoadDFMValues;
  ImportMappingLastUpdatedBy.BeforeLoadDFMValues;
  ImportMappingLastUpdated.BeforeLoadDFMValues;
  ImportMappingName.BeforeLoadDFMValues;
  ImportMappingMapping.BeforeLoadDFMValues;
  ImportMappingHasTitles.BeforeLoadDFMValues;
  EditTimer.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CloseTimer.BeforeLoadDFMValues;
  try
    Width := 939;
    Height := 611;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    FormCaption.SetParentComponent(Self);
    FormCaption.Name := 'FormCaption';
    FormCaption.Left := 72;
    FormCaption.Top := 10;
    FormCaption.Width := 92;
    FormCaption.Height := 15;
    FormCaption.Margins.Left := 5;
    FormCaption.Margins.Top := 5;
    FormCaption.Margins.Right := 5;
    FormCaption.Margins.Bottom := 5;
    FormCaption.Caption := 'Import Mappings';
    FormCaption.ElementClassName := 'HeadlineClass';
    FormCaption.ElementFont := efCSS;
    FormCaption.ElementPosition := epIgnore;
    FormCaption.HeightStyle := ssAuto;
    FormCaption.HeightPercent := 100.000000000000000000;
    FormCaption.HTMLType := tDIV;
    FormCaption.WidthStyle := ssAuto;
    FormCaption.WidthPercent := 100.000000000000000000;
    FieldDelimiterNALabel.SetParentComponent(Self);
    FieldDelimiterNALabel.Name := 'FieldDelimiterNALabel';
    FieldDelimiterNALabel.Left := 40;
    FieldDelimiterNALabel.Top := 504;
    FieldDelimiterNALabel.Width := 133;
    FieldDelimiterNALabel.Height := 15;
    FieldDelimiterNALabel.Caption := 'Not applicable (Excel file)';
    FieldDelimiterNALabel.ChildOrder := 10;
    FieldDelimiterNALabel.ElementClassName := 'form-control-plaintext';
    FieldDelimiterNALabel.ElementFont := efCSS;
    FieldDelimiterNALabel.ElementPosition := epIgnore;
    FieldDelimiterNALabel.HeightStyle := ssAuto;
    FieldDelimiterNALabel.HeightPercent := 100.000000000000000000;
    FieldDelimiterNALabel.Visible := False;
    FieldDelimiterNALabel.WidthStyle := ssAuto;
    FieldDelimiterNALabel.WidthPercent := 100.000000000000000000;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 54;
    WebPanel1.Top := 334;
    WebPanel1.Width := 561;
    WebPanel1.Height := 38;
    WebPanel1.HeightStyle := ssAuto;
    WebPanel1.WidthStyle := ssAuto;
    WebPanel1.Caption := 'WebPanel1';
    WebPanel1.ChildOrder := 20;
    WebPanel1.ElementFont := efCSS;
    WebPanel1.ElementPosition := epIgnore;
    WebPanel1.TabOrder := 0;
    WebPanel1.Visible := False;
    ImportDataTable.SetParentComponent(Self);
    ImportDataTable.Name := 'ImportDataTable';
    ImportDataTable.Left := 54;
    ImportDataTable.Top := 115;
    ImportDataTable.Width := 561;
    ImportDataTable.Height := 200;
    ImportDataTable.HeightStyle := ssAuto;
    ImportDataTable.WidthStyle := ssAuto;
    ImportDataTable.BorderColor := clSilver;
    ImportDataTable.ChildOrder := 13;
    ImportDataTable.ElementFont := efCSS;
    ImportDataTable.ElementPosition := epIgnore;
    ImportDataTable.RowCount := 5;
    MappingNameEdit.SetParentComponent(Self);
    MappingNameEdit.Name := 'MappingNameEdit';
    MappingNameEdit.Left := 400;
    MappingNameEdit.Top := 71;
    MappingNameEdit.Width := 215;
    MappingNameEdit.Height := 22;
    MappingNameEdit.AutoCompletion := acNone;
    MappingNameEdit.ChildOrder := 11;
    MappingNameEdit.ElementClassName := 'form-control';
    MappingNameEdit.ElementFont := efCSS;
    MappingNameEdit.ElementPosition := epIgnore;
    MappingNameEdit.HeightStyle := ssAuto;
    MappingNameEdit.HeightPercent := 100.000000000000000000;
    MappingNameEdit.Text := 'MappingNameEdit';
    MappingNameEdit.WidthStyle := ssAuto;
    MappingNameEdit.WidthPercent := 100.000000000000000000;
    SetEvent(MappingNameEdit, Self, 'OnChange', 'MappingNameEditChange');
    MappingNameEdit.DataField := 'Name';
    MappingNameEdit.DataSource := DataSource;
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 416;
    SaveButton.Top := 448;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 5;
    SaveButton.ElementClassName := 'btn btn-secondary';
    SaveButton.ElementPosition := epIgnore;
    SaveButton.Enabled := False;
    SaveButton.HeightStyle := ssAuto;
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthStyle := ssAuto;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CloseButton.SetParentComponent(Self);
    CloseButton.Name := 'CloseButton';
    CloseButton.Left := 519;
    CloseButton.Top := 448;
    CloseButton.Width := 96;
    CloseButton.Height := 25;
    CloseButton.Caption := 'Close';
    CloseButton.ChildOrder := 6;
    CloseButton.ElementClassName := 'btn btn-secondary';
    CloseButton.ElementPosition := epIgnore;
    CloseButton.HeightStyle := ssAuto;
    CloseButton.HeightPercent := 100.000000000000000000;
    CloseButton.WidthStyle := ssAuto;
    CloseButton.WidthPercent := 100.000000000000000000;
    SetEvent(CloseButton, Self, 'OnClick', 'CloseButtonClick');
    FieldItemCheckDlg.SetParentComponent(Self);
    FieldItemCheckDlg.Name := 'FieldItemCheckDlg';
    FieldItemCheckDlg.Left := 664;
    FieldItemCheckDlg.Top := 368;
    FieldItemCheckDlg.Width := 24;
    FieldItemCheckDlg.Height := 24;
    FieldItemCheckDlg.Buttons := [];
    FieldItemCheckDlg.Opacity := 0.200000000000000000;
    DateDelimiterEdit.SetParentComponent(Self);
    DateDelimiterEdit.Name := 'DateDelimiterEdit';
    DateDelimiterEdit.Left := 40;
    DateDelimiterEdit.Top := 536;
    DateDelimiterEdit.Width := 41;
    DateDelimiterEdit.Height := 22;
    DateDelimiterEdit.AutoCompletion := acNone;
    DateDelimiterEdit.ChildOrder := 7;
    DateDelimiterEdit.ElementClassName := 'form-control';
    DateDelimiterEdit.ElementPosition := epIgnore;
    DateDelimiterEdit.HeightStyle := ssAuto;
    DateDelimiterEdit.HeightPercent := 100.000000000000000000;
    DateDelimiterEdit.MaxLength := 1;
    DateDelimiterEdit.WidthStyle := ssAuto;
    DateDelimiterEdit.WidthPercent := 100.000000000000000000;
    SetEvent(DateDelimiterEdit, Self, 'OnExit', 'DateDelimiterEditExit');
    SetEvent(DateDelimiterEdit, Self, 'OnKeyPress', 'DateDelimiterEditKeyPress');
    DateFormatEdit.SetParentComponent(Self);
    DateFormatEdit.Name := 'DateFormatEdit';
    DateFormatEdit.Left := 112;
    DateFormatEdit.Top := 536;
    DateFormatEdit.Width := 121;
    DateFormatEdit.Height := 22;
    DateFormatEdit.AutoCompletion := acNone;
    DateFormatEdit.CharCase := wecUpperCase;
    DateFormatEdit.ChildOrder := 8;
    DateFormatEdit.ElementClassName := 'form-control';
    DateFormatEdit.ElementPosition := epIgnore;
    DateFormatEdit.HeightStyle := ssAuto;
    DateFormatEdit.HeightPercent := 100.000000000000000000;
    DateFormatEdit.MaxLength := 3;
    DateFormatEdit.WidthStyle := ssAuto;
    DateFormatEdit.WidthPercent := 100.000000000000000000;
    SetEvent(DateFormatEdit, Self, 'OnExit', 'DateFormatEditExit');
    SetEvent(DateFormatEdit, Self, 'OnKeyPress', 'DateFormatEditKeyPress');
    FieldDelimiterCombo.SetParentComponent(Self);
    FieldDelimiterCombo.Name := 'FieldDelimiterCombo';
    FieldDelimiterCombo.Left := 40;
    FieldDelimiterCombo.Top := 504;
    FieldDelimiterCombo.Width := 200;
    FieldDelimiterCombo.Height := 23;
    FieldDelimiterCombo.ChildOrder := 9;
    FieldDelimiterCombo.ElementClassName := 'form-select';
    FieldDelimiterCombo.ElementFont := efCSS;
    FieldDelimiterCombo.ElementPosition := epIgnore;
    FieldDelimiterCombo.HeightStyle := ssAuto;
    FieldDelimiterCombo.HeightPercent := 100.000000000000000000;
    FieldDelimiterCombo.WidthStyle := ssAuto;
    FieldDelimiterCombo.WidthPercent := 100.000000000000000000;
    SetEvent(FieldDelimiterCombo, Self, 'OnChange', 'FieldDelimiterComboChange');
    FieldDelimiterCombo.ItemIndex := -1;
    LoadPreviewButton.SetParentComponent(Self);
    LoadPreviewButton.Name := 'LoadPreviewButton';
    LoadPreviewButton.Left := 54;
    LoadPreviewButton.Top := 80;
    LoadPreviewButton.Width := 140;
    LoadPreviewButton.Height := 25;
    LoadPreviewButton.Caption := 'Use file as template';
    LoadPreviewButton.ElementClassName := 'btn btn-outline-primary btn-sm';
    LoadPreviewButton.ElementPosition := epIgnore;
    LoadPreviewButton.HeightStyle := ssAuto;
    LoadPreviewButton.HeightPercent := 100.000000000000000000;
    LoadPreviewButton.Visible := False;
    LoadPreviewButton.WidthStyle := ssAuto;
    LoadPreviewButton.WidthPercent := 100.000000000000000000;
    SetEvent(LoadPreviewButton, Self, 'OnClick', 'LoadPreviewButtonClick');
    PreviewFilePicker.SetParentComponent(Self);
    PreviewFilePicker.Name := 'PreviewFilePicker';
    PreviewFilePicker.Left := 200;
    PreviewFilePicker.Top := 80;
    PreviewFilePicker.Width := 33;
    PreviewFilePicker.Height := 22;
    SetEvent(PreviewFilePicker, Self, 'OnChange', 'PreviewFilePickerChange');
    AddColumnButton.SetParentComponent(Self);
    AddColumnButton.Name := 'AddColumnButton';
    AddColumnButton.Left := 200;
    AddColumnButton.Top := 80;
    AddColumnButton.Width := 140;
    AddColumnButton.Height := 25;
    AddColumnButton.Caption := 'Add column at end';
    AddColumnButton.ElementClassName := 'btn btn-outline-secondary btn-sm';
    AddColumnButton.ElementPosition := epIgnore;
    AddColumnButton.HeightStyle := ssAuto;
    AddColumnButton.HeightPercent := 100.000000000000000000;
    AddColumnButton.Visible := False;
    AddColumnButton.WidthStyle := ssAuto;
    AddColumnButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddColumnButton, Self, 'OnClick', 'AddColumnButtonClick');
    InsertAtStartButton.SetParentComponent(Self);
    InsertAtStartButton.Name := 'InsertAtStartButton';
    InsertAtStartButton.Left := 350;
    InsertAtStartButton.Top := 80;
    InsertAtStartButton.Width := 150;
    InsertAtStartButton.Height := 25;
    InsertAtStartButton.Caption := 'Insert column at start';
    InsertAtStartButton.ElementClassName := 'btn btn-outline-secondary btn-sm';
    InsertAtStartButton.ElementPosition := epIgnore;
    InsertAtStartButton.HeightStyle := ssAuto;
    InsertAtStartButton.HeightPercent := 100.000000000000000000;
    InsertAtStartButton.Visible := False;
    InsertAtStartButton.WidthStyle := ssAuto;
    InsertAtStartButton.WidthPercent := 100.000000000000000000;
    SetEvent(InsertAtStartButton, Self, 'OnClick', 'InsertAtStartButtonClick');
    FirstRowIsHeadersCheckBox.SetParentComponent(Self);
    FirstRowIsHeadersCheckBox.Name := 'FirstRowIsHeadersCheckBox';
    FirstRowIsHeadersCheckBox.Left := 54;
    FirstRowIsHeadersCheckBox.Top := 48;
    FirstRowIsHeadersCheckBox.Width := 200;
    FirstRowIsHeadersCheckBox.Height := 22;
    FirstRowIsHeadersCheckBox.Caption := 'First row is headers';
    FirstRowIsHeadersCheckBox.ChildOrder := 21;
    FirstRowIsHeadersCheckBox.ElementClassName := 'form-check-input';
    FirstRowIsHeadersCheckBox.ElementPosition := epIgnore;
    FirstRowIsHeadersCheckBox.HeightStyle := ssAuto;
    FirstRowIsHeadersCheckBox.HeightPercent := 100.000000000000000000;
    FirstRowIsHeadersCheckBox.WidthStyle := ssAuto;
    FirstRowIsHeadersCheckBox.WidthPercent := 100.000000000000000000;
    SetEvent(FirstRowIsHeadersCheckBox, Self, 'OnClick', 'FirstRowIsHeadersCheckBoxClick');
    ImportMapping.SetParentComponent(Self);
    ImportMapping.Name := 'ImportMapping';
    ImportMapping.AfterOpen := ImportMappingAfterOpen;
    ImportMapping.AfterPost := ImportMappingAfterPost;
    ImportMapping.EntitySetName := 'ImportMappings';
    ImportMapping.Connection := MainData.DataConnection;
    ImportMapping.Left := 48;
    ImportMapping.Top := 452;
    ImportMappingId.SetParentComponent(ImportMapping);
    ImportMappingId.Name := 'ImportMappingId';
    ImportMappingId.FieldName := 'Id';
    ImportMappingDateAdded.SetParentComponent(ImportMapping);
    ImportMappingDateAdded.Name := 'ImportMappingDateAdded';
    ImportMappingDateAdded.FieldName := 'DateAdded';
    ImportMappingAddedBy.SetParentComponent(ImportMapping);
    ImportMappingAddedBy.Name := 'ImportMappingAddedBy';
    ImportMappingAddedBy.FieldName := 'AddedBy';
    ImportMappingLastUpdatedBy.SetParentComponent(ImportMapping);
    ImportMappingLastUpdatedBy.Name := 'ImportMappingLastUpdatedBy';
    ImportMappingLastUpdatedBy.FieldName := 'LastUpdatedBy';
    ImportMappingLastUpdated.SetParentComponent(ImportMapping);
    ImportMappingLastUpdated.Name := 'ImportMappingLastUpdated';
    ImportMappingLastUpdated.FieldName := 'LastUpdated';
    ImportMappingName.SetParentComponent(ImportMapping);
    ImportMappingName.Name := 'ImportMappingName';
    ImportMappingName.FieldName := 'Name';
    ImportMappingName.Size := 255;
    ImportMappingMapping.SetParentComponent(ImportMapping);
    ImportMappingMapping.Name := 'ImportMappingMapping';
    ImportMappingMapping.FieldName := 'Mapping';
    ImportMappingMapping.Size := 4096;
    ImportMappingHasTitles.SetParentComponent(ImportMapping);
    ImportMappingHasTitles.Name := 'ImportMappingHasTitles';
    ImportMappingHasTitles.FieldName := 'HasTitles';
    EditTimer.SetParentComponent(Self);
    EditTimer.Name := 'EditTimer';
    EditTimer.Enabled := False;
    SetEvent(EditTimer, Self, 'OnTimer', 'EditTimerTimer');
    EditTimer.Left := 456;
    EditTimer.Top := 384;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ImportMapping;
    DataSource.Left := 280;
    DataSource.Top := 40;
    CloseTimer.SetParentComponent(Self);
    CloseTimer.Name := 'CloseTimer';
    CloseTimer.Enabled := False;
    CloseTimer.Interval := 1500;
    SetEvent(CloseTimer, Self, 'OnTimer', 'CloseTimerTimer');
    CloseTimer.Left := 72;
    CloseTimer.Top := 376;
  finally
    FormCaption.AfterLoadDFMValues;
    FieldDelimiterNALabel.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    ImportDataTable.AfterLoadDFMValues;
    MappingNameEdit.AfterLoadDFMValues;
    SaveButton.AfterLoadDFMValues;
    CloseButton.AfterLoadDFMValues;
    FieldItemCheckDlg.AfterLoadDFMValues;
    DateDelimiterEdit.AfterLoadDFMValues;
    DateFormatEdit.AfterLoadDFMValues;
    FieldDelimiterCombo.AfterLoadDFMValues;
    LoadPreviewButton.AfterLoadDFMValues;
    PreviewFilePicker.AfterLoadDFMValues;
    AddColumnButton.AfterLoadDFMValues;
    InsertAtStartButton.AfterLoadDFMValues;
    FirstRowIsHeadersCheckBox.AfterLoadDFMValues;
    ImportMapping.AfterLoadDFMValues;
    ImportMappingId.AfterLoadDFMValues;
    ImportMappingDateAdded.AfterLoadDFMValues;
    ImportMappingAddedBy.AfterLoadDFMValues;
    ImportMappingLastUpdatedBy.AfterLoadDFMValues;
    ImportMappingLastUpdated.AfterLoadDFMValues;
    ImportMappingName.AfterLoadDFMValues;
    ImportMappingMapping.AfterLoadDFMValues;
    ImportMappingHasTitles.AfterLoadDFMValues;
    EditTimer.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CloseTimer.AfterLoadDFMValues;
  end;
end;

end.
